import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { closePopover } from '../../actions/popover'
import { fetchComments, clearAllComments } from '../../actions/statuses'
import { changeSetting, saveSettings } from '../../actions/settings'
import {
  COMMENT_SORTING_TYPE_NEWEST,
  COMMENT_SORTING_TYPE_OLDEST,
  COMMENT_SORTING_TYPE_TOP,
} from '../../constants'
import PopoverLayout from './popover_layout'
import List from '../list'

class CommentSortingOptionsPopover extends React.PureComponent {

  handleOnClick = (type) => {
    this.handleOnClosePopover()
    this.props.onSetCommentSortingSetting(type)
  }

  handleOnClosePopover = () => {
    this.props.onClosePopover()
  }

  render() {
    const { commentSorting, isXS } = this.props

    const items = [
      {
        hideArrow: true,
        isActive: commentSorting === COMMENT_SORTING_TYPE_NEWEST,
        title: 'Recent',
        subtitle: "Show all comments, with the newest comments first.",
        onClick: () => this.handleOnClick(COMMENT_SORTING_TYPE_NEWEST),
      },
      {
        hideArrow: true,
        isActive: commentSorting === COMMENT_SORTING_TYPE_OLDEST,
        title: 'Oldest',
        subtitle: 'Show all comments, with the oldest comments first.',
        onClick: () => this.handleOnClick(COMMENT_SORTING_TYPE_OLDEST),
      },
      {
        hideArrow: true,
        isActive: commentSorting === COMMENT_SORTING_TYPE_TOP,
        title: 'Most Liked',
        subtitle: 'Show all comments, with the most liked top-level comments first.',
        onClick: () => this.handleOnClick(COMMENT_SORTING_TYPE_TOP),
      },
    ]
    
    return (
      <PopoverLayout
        width={280}
        isXS={isXS}
        onClose={this.handleOnClosePopover}
      >
        <List
          size={isXS ? 'large' : 'small'}
          scrollKey='comment_sorting_options'
          items={items}
        />
      </PopoverLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  commentSorting: state.getIn(['settings', 'commentSorting']),
})

const mapDispatchToProps = (dispatch, { statusId }) => ({
  onSetCommentSortingSetting(type) {
    dispatch(changeSetting(['commentSorting'], type))
    dispatch(saveSettings())
    dispatch(clearAllComments(statusId))
    dispatch(fetchComments(statusId, false, true))
    dispatch(closePopover())
  },
  onClosePopover: () => dispatch(closePopover()),
})

CommentSortingOptionsPopover.propTypes = {
  commentSorting: PropTypes.string.isRequired,
  isXS: PropTypes.bool,
  onClosePopover: PropTypes.func.isRequired,
  statusId: PropTypes.string.isRequired,
  onSetCommentSortingSetting: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(CommentSortingOptionsPopover)